import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import React from "react";
import linkIcon from "../../../../assets/images/sub/purchase_voucher/link_icon.svg";
import {useUserAgent} from "../../../../hooks/hooks";
import {useTranslation} from "react-i18next";

interface Args {
    isAgreed: boolean;
    onClickAgreeBtn: (_: boolean) => void
    onClickTermsLink: (_: React.MouseEvent) => void
}

export function AgreementField({isAgreed, onClickAgreeBtn, onClickTermsLink}: Args) {
    const { t } = useTranslation("order");
    const {isMobile} = useUserAgent();
    return (
        isMobile ? (
            <div className={`${style.agreement} ${style.mobile}`}>
                <div className={style.checkBtnWrap}>
                    <button
                        className={`${style.checkBtn} ${isAgreed ? style.checked : ""}`}
                        onClick={() => onClickAgreeBtn(isAgreed)}
                    />
                </div>
                <div className={style.textWrap}>
                    <span className={style.text}>{t("terms.desc")}</span>
                    <div className={style.linkWrap}>
                <span className={style.link} onClick={onClickTermsLink}>
                  {t("terms.detail")}
                </span>
                        <img src={linkIcon} alt={"자세히 보기 아이콘"}/>
                    </div>
                </div>
            </div>
        ) : (
            <div className={`${style.agreement} ${style.desktop}`}>
                <button
                    className={`${style.checkBtn} ${isAgreed ? style.checked : ""}`}
                    onClick={() => onClickAgreeBtn(isAgreed)}
                />
                <span className={style.text}>{t("terms.desc")}</span>
                <span className={style.link} onClick={onClickTermsLink}>
              {t("terms.detail")}
            </span>
            </div>

        )
    )
}